import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { references } from '@apexdesigner/schema-tools';

export const pdfDocument = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    fileName: z.string().nullable().optional().describe('File Name'),

    mimeType: z.string().nullable().optional().describe('Mime Type'),

    size: z.number().nullable().optional().describe('Size'),

    base64Content: z
      .string()
      .nullable()
      .optional()
      .hidden()
      .describe('Base64 Content'),

    locked: z.boolean().nullable().optional().hidden().describe('locked'),

    resourceId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Resource'),

    testArticleId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to TestArticle'),

    resource: references('Resource'),

    testArticle: references('TestArticle'),
  })
  .describe(
    'A PDF file backing a resource (or, once assessments is migrated, a test article).',
  )
  .as('PdfDocument');

export { pdfDocument as pdfDocumentSchema };
